type Helpers = {
  [key: string]: (...args: unknown[]) => unknown;
};

const helpers: Helpers = {};

export default helpers;
